<template>
    <div class="pro_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <li class="li-title_1">采集箱</li>
                    <li class="li-title_2 title-2-select" @click="title2Click($event,'/product/lazada/coll')">「Lazada」采集箱 (210)</li>
                    <li class="li-title_1">
                        待发布产品
                        <a class="a-set blueCo" href="javascript:void(0)" @click="setClassManage">设置</a>
                    </li>
                    <li class="li-title_2 tree-item">
                        <!--<el-tree :data="treeData" :props="defaultProps" @node-click="waitForPost"></el-tree>-->
                        <el-tree style="text-align: center;"  :props="defaultProps"
                                 :load="loadNode" lazy
                                 @node-click="waitForPost"></el-tree>
                    </li>
                    <li class="li-title_2" @click="title2Click($event,'/product/lazada/interval')">定时发布 ({{TimeInterval}})</li>
                    <li class="li-title_2" @click="title2Click($event,'/product/lazada/releasing')">发布中 ({{releasing}})</li>
                    <li class="li-title_2" @click="title2Click($event,'/product/lazada/releaseFail')">发布失败 ({{releaseFail}})</li>
                    <li class="li-title_1">
                        在线产品
                        <a class="a-set blueCo" href="javascript:void(0)" @click="setClassManage">设置</a>
                    </li>
                    <li class="li-title_2 tree-item">
                        <el-tree style="text-align: center;"  :props="defaultProps"
                                 :load="loadNode" lazy
                                 @node-click="waitForPost"></el-tree>
                    </li>
                    <li class="li-title_1">其他</li>
                    <li class="li-title_2" @click="title2Click($event,'/product/lazada/createProduct')">创建产品</li>
                </ul>
            </el-aside>
            <el-main>
                <router-view>

                </router-view>
             </el-main>
        </el-container>
        <ClassManage @closeCMDialog_z="closeCMDialog_f" :classManageDialog="classManageDialog"></ClassManage>
    </div>
</template>

<script type="text/ecmascript-6">
    import ClassManage from '@/components/product/ClassManage'
    import {getTreeList,verSearch} from '@/api/product/lazada'
    import {handleTree} from '@/utils/jn'
    import {mapGetters} from 'vuex'
    export default {
        name: "index",
        components:{
            ClassManage
        },
        data() {
            return {
                classManageDialog:false,//管理分类弹窗默认关闭
                defaultProps: {
                    children: 'children',
                    label: 'typeNme',
                    value:'id'
                },
                treeData:[],
                count:1,
                releaseFail:0,
                releasing:0,
                TimeInterval:0
            }
        },
        computed:{
                ...mapGetters(['lazadaTotal']),
            currentTime(){
                    return this.$store.state.product.lazada.currentTime;
            }
        },
        watch:{
            currentTime(o,n){
                this.getSearch();
            }
        },
        created() {
            //查询左边树
            this.getSearch();
        },
        methods: {
            getSearch:function(){
                let that =this;
                //重置数据
                that.releaseFail=0;
                that.releasing =0;
                that.TimeInterval=0;
                verSearch().then(function(res){
                    //遍历结果
                    res.data.forEach((item,index) => {
                        if(item.pubStatus=='04'){
                            that.releaseFail = res.data[index].cnt;
                        }
                        if(item.pubStatus=='03'){
                            that.releasing = res.data[index].cnt;
                        }
                        if(item.pubStatus=='08'){
                            that.TimeInterval = res.data[index].cnt;
                        }

                })

                })
            },
            title2Click(e,url){
                var _dom = document.querySelector('.li-title_2.title-2-select');
                if (_dom) {
                    _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('title-2-select');
                this.$router.push(url);
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            //待发布产品树点击事件
            waitForPost(val,node,tree){
                this.$router.push({path:'/product/lazada/readyRelease',query:{id:node.data.typeNo==0?'':node.data.typeNo}})
            },
            onLineChange(val,node,tree){
                this.$router.push({path:'/lazada/onLine'})
            },

            /**
             * 加载动态树
             */
            loadNode(node, resolve) {
                var that =this;
                if (node.level === 0) {
                    //查询顶级节点
                    let params = {};
                    getTreeList(params).then(function(res){
                        that.treeData = that.createTreeData(res.data);
                        console.log(that.treeData);
                        return resolve(that.treeData);
                    }).catch(function(error){
                        this.$message.error(res.msg);
                    });
                }else {
                    let params = {pTypeNo:node.data.id};
                    // 根据父节点id找寻下一级的所有节点
                    getTreeList(params).then(res => {
                        return resolve(res.data);
                });
                }

            },

            createTreeData(data){
                let treedata = data.filter(father =>{
                            if(father['pTypeNo'] == ""||father['pTypeNo'] == null){
                    father['pTypeNo'] = '0'
                }
                let childArr = data.filter(child =>{
                            return  child['pTypeNo'] == father.id;
            });
                childArr.length > 0?father.children =childArr:'';
                return father['pTypeNo'] == '0';
            });
                return treedata ;
            },


        },
        mounted() {}
    }
</script>

<style scoped>
    @import '../../../assets/css/product.css';
    @import '../../../assets/css/Lazada.css';
    .pro_index{
        width: 100%;
    }

    .title-2-select{
        background-color: #4934b2;
        color: white;
        cursor: pointer;
    }
</style>
